// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4795) return "static/chunks/4795-6fb03a9fc3aa783e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "f5803e0183b5c89e" + ".js";
};